var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"payload-style"},[_vm._v(" "+_vm._s(_vm.prettyJson || _vm.$t('form.noData'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }